import { AuthVariant } from '../types';

export const isOnboardingAuth = (variant: AuthVariant) =>
  variant === 'onboarding';

export const isPaywallAuth = (variant: AuthVariant) => variant === 'paywall';
